import React, { useEffect } from "react";
import { Form, Input, Button, Flex, Radio, Select } from "antd";
import { Device } from "../../../types/device";
import TextArea from "antd/es/input/TextArea";

interface ProductFormProps {
  initialValues: Device;
  onSubmit: (values: Device) => void;
}

const ProductForm: React.FC<ProductFormProps> = ({ initialValues, onSubmit }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    } else {
      form.resetFields();
    }
  }, [initialValues, form]);
  return (
    <Form form={form} initialValues={initialValues} onFinish={onSubmit}
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 18 }}
    >
      <Form.Item
        name="pid"
        label="PID"
        rules={[
          {
            required: true,
            message: "Vui lòng không để trống PID",
          },
        ]}
      >
        <Input disabled/>
      </Form.Item>
      <Form.Item
        name="product_name"
        label="Tên sản phẩm"
        rules={[
          {
            required: true,
            message: "Vui lòng không để trống tên sản phẩm",
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item label="Device type" name="device_type" >
        <Flex vertical gap="middle">
          <Radio.Group block options={[
            {
              value: "Common Device",
              label: "Common Device",
            },
            {
              value: "Gateway Device",
              label: "Gateway Device",
            },
            {
              value: "Gateway Sub Device",
              label: "Gateway Sub Device",
            },
          ]} defaultValue="Common Device" />
     
        </Flex>
      </Form.Item>
      <Form.Item name="protocol_type" 
      label="Protocol"
      rules={[
        {
          required: true,
          message: "Vui lòng chọn protocol!",
        },
      ]}
      >
        <Select
          showSearch
          placeholder="Protocol"
          optionFilterProp="label"
          options={[
            {
              value: "Wifi",
              label: "Wifi",
            },
            {
              value: "Wifi & BLE",
              label: "Wifi & BLE",
            },
            {
              value: "Bluetooth Mesh",
              label: "Bluetooth Mesh",
            },
            {
                value: "Bluetooth",
                label: "Bluetooth",
              },
              {
                value: "LTE 4G",
                label: "LTE 4G",
              },
              {
                value: "Ethernet",
                label: "Ethernet",
              },
          ]}
        />
      </Form.Item>
      <Form.Item label="Product description" name="product_desc">
          <TextArea/>
      </Form.Item>
      <Form.Item label={null}>
        <Button type="primary" htmlType="submit">
          Lưu
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ProductForm;
